import NodeSourceGeometry from "./nodeSourceGeometry";
class CommonPropertiesWithGeometry extends NodeSourceGeometry {
    constructor(Created, Description, Color, NodeWidth, NodeHeight) {
        super(NodeWidth, NodeHeight);
        this.Created = Created || Date.now();
        this.Description = Description;
        this.Color = Color;
    }
}
export default CommonPropertiesWithGeometry;
